import React, { useState, useEffect, useRef } from "react";

import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";
import moment from "moment";

import {
  Table,
  Empty,
  Col,
  Row,
  Tooltip,
  Tabs,
  Input,
  Button,
  Popconfirm,
  notification,
} from "antd";
import {
  BarsOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  SendOutlined,
} from "@ant-design/icons";
import { odata } from "../Filters/Helper";
import ErpDbsInvoiceTableFilter from "../Filters/ErpDbsInvoiceTableFilter";

const ErpDbsInvoice = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    activeTab: "0",
  });
  const [order, setOrder] = useState("");
  const [columnSettings, setColumnSettings] = useState();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  useEffect(() => {
    getColumnSettings();
  }, []);

  useEffect(() => {
    if (columnSettings) {
      getTableData();
    }
  }, [order, tableDataQueryOptions, columnSettings]);

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const getFilterQuery = () => {
    const { filter, activeTab } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (activeTab !== "-1") {
      conditions.push(`erpTransferStatusId Eq ${activeTab}`);
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    return query;
  };
  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/ErpSendDbsInvoice?$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      } else {
        setTableData({
          data: tableData.data,
          total: tableData.total,
          loading: false,
        });
      }
    });
  };
  const getColumnSettings = () => {
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {
        setColumnSettings(response);
      } else {
        //erp tanımlı değilse sadece table loaderı kaldırdık
        setTableData({ ...tableData, loading: false });
      }
    });
  };

  const isExportAvailable =
    tableDataQueryOptions.activeTab === "0" ||
    tableDataQueryOptions.activeTab === "3";

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
      activeTab: tableDataQueryOptions.activeTab,
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        skip: 0,
        current: 1,
        take: prevState.take,
        filter: query,
        activeTab: prevState.activeTab,
      };
    });
  };

  const erpDbsInvoiceColumns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      align: "center",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Bayi Adı",
      dataIndex: "dbsDealerName",
    },
    {
      title: "Bayi Kodu",
      dataIndex: "dealerCode",
    },
    {
      title: "Fatura Tarihi",
      dataIndex: "invoiceDate",
      sorter: true,
      key: "invoiceDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Vade Tarihi",
      dataIndex: "dueDate",
      sorter: true,
      key: "dueDate",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Fatura Numarası",
      dataIndex: "invoiceNumber",
    },
    {
      title: "Fatura Tutarı",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Şube Kodu",
      dataIndex: "branchCode",
      key: "BranchCode",
      render: (data, row, index) => {
        if (row.isEditableBranchCode) {
          return (
            <Input
              value={data}
              disabled={!isExportAvailable}
              maxLength={100}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  branchCode: event.target.value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
            />
          );
        }
        return data;
      },
    },
    {
      title: "Açıklama",
      dataIndex: "description",
    },

    {
      title: "Evrak No",
      dataIndex: "documentNumber",
      align: "center",
    },
    {
      title: "Durum",
      dataIndex: "erpTransferStatusId",
      align: "center",
      render: (i, row) => {
        const icon = {
          0: {
            component: <InfoCircleOutlined />,
          },
          1: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
          2: {
            color: "orange",
            component: <ClockCircleOutlined />,
          },

          3: {
            color: "red",
            component: <CloseCircleOutlined />,
          },
        };
        return (
          <Tooltip
            title={
              row.erpTransferStatus === "Başarısız"
                ? row.errorMessage
                : row.erpTransferStatus
            }
          >
            <a style={{ fontSize: "130%", color: icon[i].color }}>
              {icon[i].component}
            </a>
          </Tooltip>
        );
      },
    },
  ];

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
  };

  const onConfirmSuccessfulExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (isSuccess) {
      RequestHandler.post(
        "/ErpDbsInvoice/SetSuccessfulTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
          setSelectedRowKeys([]);
        }
      });
    }
  };

  const onConfirmNotTransferredExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    RequestHandler.post(
      "/ErpDbsInvoice/SetNotTransferredTransfer",
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
        setSelectedRowKeys([]);
      }
    });
  };

  const onConfirmExport = () => {
    let isSuccess = true;

    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    // DealerErpBankAccountCode valuesu olmayan bir invoice seçili ise
    if (
      selectedRowsData.some(
        (row) =>
          row.dealerErpBankAccountCode === null ||
          row.dealerErpBankAccountCode.trim() === ""
      )
    ) {
      notification.error({
        message:
          "Seçili Dbs Faturaları içerisinde Bayi Banka Hesap Kodu olmayan kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

    setTableData({
      ...tableData,
      loading: true,
    });

    if (isSuccess) {
      RequestHandler.post(
        "/ErpDbsInvoice/ExportInvoices",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
          setSelectedRowKeys([]);
        } else {
          isSuccess = false;
        }
      });
    }
    getTableData();
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> ERP DBS FATURA LİSTESİ
          </p>
        </Col>
        <Col
          xs={tableDataQueryOptions.activeTab === "1" ? 24 : 24}
          md={tableDataQueryOptions.activeTab === "1" ? 24 : 8}
          lg={tableDataQueryOptions.activeTab === "1" ? 6 : 4}
          xl={tableDataQueryOptions.activeTab === "1" ? 8 : 6}
          style={{
            textAlign: "right",
            paddingLeft: "0px",
          }}
        >
          <Popconfirm
            title={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? "Aktarıldı olarak işaretlensin mi?"
                : "Aktarılmadı olarak işaretlensin mi?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? onConfirmSuccessfulExport
                : onConfirmNotTransferredExport
            }
            style={{ color: "seagreen" }}
          >
            {(tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "1" ||
              tableDataQueryOptions.activeTab === "3") && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined />{" "}
                {(tableDataQueryOptions.activeTab === "0" ||
                  tableDataQueryOptions.activeTab === "3") &&
                  "Aktarıldı Yap"}
                {tableDataQueryOptions.activeTab === "1" && "Aktarılmadı Yap"}
              </Button>
            )}
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={2}
          style={{ textAlign: "right" }}
          hidden={tableDataQueryOptions.activeTab === "1"}
        >
          <Popconfirm
            title="Aktarmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            {isExportAvailable && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined /> Erp'ye Aktar
              </Button>
            )}
          </Popconfirm>
        </Col>
      </Row>

      <ErpDbsInvoiceTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Tümü" key="-1" />
        <Tabs.TabPane tab="Aktarılmadı" key="0" />
        <Tabs.TabPane tab="Başarılı" key="1" />
        <Tabs.TabPane tab="Aktarılıyor" key="2" />
        <Tabs.TabPane tab="Başarısız" key="3" />
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={erpDbsInvoiceColumns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            rowSelection={
              isExportAvailable
                ? {
                    selectedRowKeys: selectedRowKeys,
                    onChange: onTableSelectChange,
                  }
                : tableDataQueryOptions.activeTab === "1"
                ? {
                    selectedRowKeys: selectedRowKeys,
                    onChange: onTableSelectChange,
                  }
                : undefined
            }
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
              showSizeChanger: true,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
};

export default ErpDbsInvoice;
